import { useEffect, useState } from 'react';
import useThrottledCallback from '@src/hooks/useThrottledCallback';
type TBoundingClientRect = {
  height: number;
  width: number;
  top: number;
  bottom: number;
  left: number;
  right: number;
  x: number;
  y: number;
};

function useBoundingClientRect(el: HTMLElement | null | undefined) {
  const [box, setBox] = useState<TBoundingClientRect | null | undefined>(null);
  const handleChange = useThrottledCallback(() => {
    if (!el) return;

    const rect = el.getBoundingClientRect();

    setBox({
      height: rect.height,
      width: rect.width,
      top: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      right: rect.right,
      x: rect.left,
      y: rect.top
    });
  }, [el]);

  useEffect(() => {
    const handler = (event: any) => {
      handleChange();
    };

    window.addEventListener('resize', handler);
    document.addEventListener('scroll', handler);

    handler();

    return () => {
      window.removeEventListener('resize', handler);
      document.addEventListener('scroll', handler);
    };
  }, [handleChange]);

  return box;
}

export default useBoundingClientRect;
